import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-sep-default', // Keep existing selector
    templateUrl: './sep/sep_default/sep-default.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, TranslocoModule, PipesModule]
})
export class SepDefaultComponent extends UnitsDistributionBase {
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}
